import type { ReactElement } from "react";

import { Stack, Box } from "@similarweb/ui-components/foundations";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type LegacyIndustryFilterModel from "app/pages/sales-intelligence/modules/leads-search-filters/models/LegacyIndustryFilter/LegacyIndustryFilterModel";

import { IndustryDemoCallout } from "./IndustryDemoCallout";
import LegacyIndustryFilter from "./LegacyIndustryFilter";

/** Legacy industry filter with the v2 demo promo above it — used on search surfaces where the demo is offered. */
const LegacyIndustryFilterWithDemoCallout = (props: IFilterViewBaseProps<LegacyIndustryFilterModel>): ReactElement => (
    <Stack gap="16px">
        <Box padding="0 32px 0 0">
            <IndustryDemoCallout />
        </Box>
        <LegacyIndustryFilter {...props} />
    </Stack>
);

export default LegacyIndustryFilterWithDemoCallout;
